import { useState } from "react";
import { ChevronDown, Wallet } from "lucide-react";
import formatCurrency from "@/utils/formatCurrency";
import IncomeRow from "@/components/dashboard/IncomeRow";

const IncomeAccordion = ({ category, incomes, onUpdate, icons }) => {
  const [isOpen, setIsOpen] = useState(false);
  const categoryIncomes = incomes.filter((i) => i.category === category && i.subcategory);
  const categoryTotal = categoryIncomes.reduce((sum, i) => sum + (i.is_monthly ? i.monthly_amount * 12 : i.yearly_amount), 0);

  if (categoryIncomes.length === 0) return null;

  return (
    <div className="border-b border-gray-100" data-testid={`income-accordion-${category.replace(/\s+/g, '-').toLowerCase()}`}>
      <button className="accordion-trigger" onClick={() => setIsOpen(!isOpen)}>
        <div className="flex items-center gap-3">
          <div className="category-icon">{icons[category] ? (() => { const Icon = icons[category]; return <Icon size={20} />; })() : <Wallet size={20} />}</div>
          <span className="font-semibold text-gray-800">{category}</span>
        </div>
        <div className="flex items-center gap-4">
          <span className="text-gray-600 font-medium">₹{formatCurrency(categoryTotal)}</span>
          <ChevronDown className={`chevron-icon text-gray-400 ${isOpen ? "rotate-180" : ""}`} size={20} />
        </div>
      </button>
      {isOpen && (
        <div className="px-4 pb-4 space-y-3">
          {categoryIncomes.map((income) => {
            const globalIndex = incomes.findIndex((i) => i.category === income.category && i.subcategory === income.subcategory);
            const IconComponent = icons[income.subcategory] || Wallet;
            return (
              <IncomeRow
                key={`${income.category}-${income.subcategory}`}
                icon={IconComponent}
                label={income.subcategory}
                income={income}
                onUpdate={onUpdate}
                index={globalIndex}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default IncomeAccordion;
